export default "__VITE_ASSET__4cnZO5zm__"